import {
  NotificationType,
  PhoneData,
  ProfileNewPasswordData,
  ProfileQualityData,
  QualityReservationOption,
  ProfileGeneralData,
  PaginatedData,
  Order,
  NotificationSettings,
} from "@/types";
import { AxiosInstance } from "axios";

export class ProfileApi {
  constructor(private axios: AxiosInstance) {}

  save(data: ProfileGeneralData): Promise<void> {
    return this.axios.post(`/profile/data_update`, data);
  }

  changePassword(data: ProfileNewPasswordData): Promise<void> {
    return this.axios.post(`/profile/password`, data);
  }

  submitQualityForm(data: ProfileQualityData): Promise<void> {
    const formData = new FormData();
    formData.set("reservation_id", String(data.reservation_id.reservation_id));

    data.products.forEach(({ quantity, product }, index) => {
      formData.set(`products[${index}][id]`, String(product.id));
      formData.set(`products[${index}][quantity]`, String(quantity));
    });

    formData.set("description", data.description);

    data.images.forEach((image) => formData.append("images[]", image));

    formData.set("nps_quality", String(data.nps_quality));
    formData.set("nps_pickup", String(data.nps_pickup));
    if (data.nps_improvement) {
      formData.set("nps_improvement", data.nps_improvement);
    }

    return this.axios.post(`/support/form`, formData);
  }

  getQualityReservationOptions(): Promise<QualityReservationOption[]> {
    return this.axios
      .get<QualityReservationOption[]>("/support/listReservations")
      .then((r) => r.data);
  }

  setNotification(
    type: NotificationType,
    value: boolean,
    additionalData?: Record<string, any>
  ): Promise<void> {
    return this.axios.post(`/notifications/${type}?isActive=${value}`, {
      ...additionalData,
    });
  }

  updatePhone(data: PhoneData): Promise<void> {
    return this.axios.post(`/profile/phone_update`, data);
  }

  getOrders(page: number): Promise<PaginatedData<Order>> {
    return this.axios
      .get<PaginatedData<Order>>(`/profile/orders`, {
        params: { page },
      })
      .then((r) => r.data);
  }

  changeLang(lang: string): Promise<void> {
    return this.axios.get(`/lang/${lang}`);
  }

  getNotificationSettings(): Promise<NotificationSettings | null> {
    return this.axios
      .get<NotificationSettings | []>("/notifications/current")
      .then((r) => r.data)
      .then((data) => (Array.isArray(data) ? null : data));
  }
}
